// AboutUs.jsx

import React from 'react';
import {
  Box,
  Typography,
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Card,
  Link,
  CardContent,
  ListItemAvatar,
  Grid,
} from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import NavBar from './NavBar';
import Footer from './Footer';

const AboutUs = () => {
  const values = [
    {
      title: 'Integrity',
      description:
        'We prioritize transparency, honesty, and ethical practices in everything we do. Building lasting relationships on mutual respect is at the heart of our service.',
    },
    {
      title: 'Client-Focused Service',
      description:
        'Your goals are our mission. We listen, understand, and tailor our services to meet your unique challenges.',
    },
    {
      title: 'Commitment to Excellence',
      description:
        'We strive to deliver top-tier service by staying informed on the latest regulations, trends, and best practices.',
    },
    {
      title: 'Proactive and Agile',
      description:
        'In today’s fast-evolving financial world, we remain one step ahead—adapting our strategies and keeping clients well-informed and future-ready.',
    },
  ];

  return (
    <Box id="aboutus">
      <NavBar />

      <Box sx={{ bgcolor: '#f5f5f5', py: 6, mt: 2 }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            backgroundColor: '#00B140',
            color: '#fff',
            mb: 6,
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          About Us
        </Typography>

        <Container maxWidth="md">
          <Card elevation={3} sx={{ mb: 4, px: 2 }}>
            <CardContent sx={{ maxWidth: '850', margin: '0 auto' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#00B140', mb: 2 }}>
                Who We Are
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                <strong>PDN & ASSOCIATES</strong> is a trusted Chartered Accountancy firm located in Bellandur, Bangalore, offering high-quality accounting, taxation, and compliance services.
              </Typography>
              <Typography variant="body1">
                With a strong emphasis on ethics, trust, and expertise, we empower clients to navigate complex financial landscapes with confidence and precision.
              </Typography>
            </CardContent>
          </Card>

          <Card elevation={3} sx={{ mb: 4, px: 2 }}>
            <CardContent sx={{ maxWidth: '850px', margin: '0 auto' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#00B140', mb: 2 }}>
                Our Story
              </Typography>
              <Typography variant="body1" sx={{ mb: 1 }}>
                Founded by PDN, a seasoned Chartered Accountant, the firm started with a vision to deliver value-driven financial solutions.
              </Typography>
              <Typography variant="body1">
                From a small practice to a firm now serving 50+ clients across industries, our growth reflects our commitment to excellence and client success.
              </Typography>
            </CardContent>
          </Card>

          <Card elevation={3} sx={{ px: 2 }}>
            <CardContent sx={{ maxWidth: '850px', margin: '0 auto' }}>
              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#00B140', mb: 3 }}>
                Our Core Values
              </Typography>

              <List>
                {values.map((item, index) => (
                  <ListItem key={index} alignItems="flex-start" sx={{ mb: 2 }}>
                    <ListItemIcon>
                      <CheckCircleOutline sx={{ color: '#00B140' }} />
                    </ListItemIcon>
                    <ListItemText
                      primary={<Typography sx={{ fontWeight: 'bold' }}>{item.title}</Typography>}
                      secondary={item.description}
                    />
                  </ListItem>
                ))}
              </List>
              
            </CardContent>
            
          </Card>
          
          
        </Container>
        
      </Box>
      <Box sx={{ bgcolor: '#eae9e9ff', py: 8 }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            color: '#00B140',
            mb: 1,
            fontFamily: 'Roboto, sans-serif'
          }}
        >
          GET IN TOUCH
        </Typography>

        <Link
          href="mailto:devarajuassociates@gmail.com"
          underline="none"
          sx={{
            color: '#00B140',
            fontWeight: 'bold',
            fontSize: '1.4rem',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          INFO@PDNANDASSOCIATES.COM
        </Link>
      </Container>
    </Box>

      <Footer />
    </Box>
  );
};

export default AboutUs;
